import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=66c92b32&scoped=true&"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js&"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js&"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=66c92b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c92b32",
  null
  
)

export default component.exports